import { ReactElement, useEffect } from "react";

import useContractDetails from "hooks/api/contracts/useContractDetails";
import { DEFAULT_EMPTY_VALUE } from "util/statHelpers";

import TermsPanel from "./TermsPanel";
import { Stack } from "@chakra-ui/react";
import { detailsBodyPadding } from "util/styleHelpers";

const ContractTab = ({
  setErrorMessage,
  filters,
}: DetailsTabProps): ReactElement => {
  const { data: contract, error } = useContractDetails();

  useEffect(() => {
    if (error && setErrorMessage) {
      setErrorMessage((error as Error).message);
    }
  }, [setErrorMessage, error]);

  return (
    <Stack pt={detailsBodyPadding}>
      <TermsPanel
        unitOfMeasure={contract?.unitOfMeasure ?? DEFAULT_EMPTY_VALUE}
        currency={contract?.currency ?? DEFAULT_EMPTY_VALUE}
        filterDefinitions={filters}
      />
    </Stack>
  );
};

export default ContractTab;
